import React, {useRef, useState} from 'react';
import './CodePicker.less';
import {CodePickerDigit} from "elements/code-picker-digit/CodePickerDigit";
import times from "lodash/times";

function getEnteredValueWithDigitRemoved(currentValue, changedIndex) {
	if (currentValue[changedIndex].length === 1) {
		return currentValue.map((digit, index) => (index === changedIndex ? '' : digit));
	} else if (currentValue[changedIndex].length === 0 && changedIndex > 0) {
		return currentValue.map((digit, index) => (index === changedIndex - 1 ? '' : digit));
	}

	return currentValue;
}

function getEnteredValueWithDigitAdded(currentValue, changedIndex, enteredDigit) {
	return currentValue.map((digit, index) => (index === changedIndex ? enteredDigit : digit));
}

export const CodePicker = ({enteredValue = [], onChange, isHidden, ariaDigitLabel}) => {

	const [focusedIndex, setFocusedIndex] = useState(0);

	function onDigitChange(newDigitValue, changedIndex) {
		let nextFocusedIndex;

		if (newDigitValue) {
			onChange(getEnteredValueWithDigitAdded(enteredValue, changedIndex, newDigitValue));
			nextFocusedIndex = focusedIndex + 1;
		} else {
			onChange(getEnteredValueWithDigitRemoved(enteredValue, changedIndex));
			nextFocusedIndex = focusedIndex - 1;
		}

		if (nextFocusedIndex > enteredValue.length - 1) {
			nextFocusedIndex = enteredValue.length - 1;
		}

		if (nextFocusedIndex < 0) {
			nextFocusedIndex = 0;
		}

		setFocusedIndex(nextFocusedIndex);
	}

	return <ul className="code-picker">
		{times(enteredValue.length, i => (
			<li className="code-picker__digit" key={i}>
				<CodePickerDigit
					value={enteredValue[i]}
					isHidden={isHidden}
					index={i}
					onChange={onDigitChange}
					onFocus={index => setFocusedIndex(index)}
					ariaDigitLabel={ariaDigitLabel}
					isFocused={i === focusedIndex}
				/>
			</li>
		))}
	</ul>
}
